// extracted by mini-css-extract-plugin
export default {"content":"styles_content__n2y8P","center_content":"styles_center_content__1VNfW","test_background":"styles_test_background__4mfQ2"};